import type { MutationHookOptions } from "@apollo/client";
import { gql, useMutation } from "@apollo/client";

import type { VariantFragment } from "@shared/data/fragments/VariantFragment/VariantFragment.fragment";

const PractitionerVariantNotificationCreate_ClinicShared_Mutation = gql`
  mutation PractitionerVariantNotificationCreate_ClinicShared_Mutation(
    $input: PractitionerVariantNotificationInput!
  ) {
    practitionerVariantNotificationCreate(input: $input) {
      errors
      variant {
        id
        isBackorderNotifiable
        isBackorderNotificationSubscribed
      }
    }
  }
`;

interface VariantSplinter extends Pick<VariantFragment, "id" | "isBackorderNotifiable"> {
  isBackorderNotificationSubscribed: boolean;
}

interface PractitionerVariantNotificationCreateData {
  practitionerVariantNotificationCreate: {
    errors: string[];
    variant: VariantSplinter;
  };
}

interface Variables {
  input: {
    variantId: string;
  };
}

const usePractitionerVariantNotificationCreateMutation = (
  options?: MutationHookOptions<PractitionerVariantNotificationCreateData, Variables>
) =>
  useMutation<PractitionerVariantNotificationCreateData, Variables>(
    PractitionerVariantNotificationCreate_ClinicShared_Mutation,
    options
  );

export type { PractitionerVariantNotificationCreateData };

/* eslint-disable @fullscript/gql-no-manual-hook-declaration */
export {
  PractitionerVariantNotificationCreate_ClinicShared_Mutation,
  usePractitionerVariantNotificationCreateMutation,
};
